import { ITranslations } from "../../ReportBuilder/models/translations";
export var translations = {
    scopesDropdownTitle: "Business scope (domain) ",
    scopesPlaceholder: "Scope",
    dataModelsDropdownTitle: "Data source",
    dataModelsPlaceholder: "Data source",
    contentTitle: "Report options",
    dimensionsListTitle: "Dimensions",
    dimensionPlaceholder: "Select dimension",
    noDimensionsText: "No dimensions found",
    addDimensionButtonText: "Add dimension",
    metricsListTitle: "Metrics",
    metricPlaceholder: "Select metric",
    noMetricsText: "No metrics found",
    addMetricButtonText: "Add metric",
    filtersText: "Filters",
    addFilterButton: "Add filter",
    optionalLabel: "optional",
    rowsOffset: "Start with row",
    rowsLimit: "Limit number of rows to",
    chartTab: "Chart",
    tableTab: "Table",
    filterTypePlaceholder: "Filter Type",
    filterOperationPlaceholder: "Operation",
    filterFromLabel: "from",
    filterToLabel: "to",
    filterValuesDescription: "The possible values have to be separated by a semicolon.",
    filterValuesExample: "Example",
    filterTypeDateRange: "Date Range",
    filterTypeSingleKey: "Single Key",
    filterTypeSingleValue: "Single Value",
    filterSingleKeyPlaceholder: "Key",
    filterSingleValueKeysPlaceholder: "Keys",
    filterSingleValuePlaceholder: "Value",
    filterOperationEquals: "EQUALS",
    filterOperationNotEquals: "NOT_EQUALS",
    filterOperationStartsWith: "STARTS_WITH",
    filterOperationNotStartsWith: "NOT_STARTS_WITH",
    filterOperationEndsWith: "ENDS_WITH",
    filterOperationNotEndsWith: "NOT_ENDS_WITH",
    filterOperationContains: "CONTAINS",
    filterOperationNotContains: "NOT_CONTAINS",
    filterOperationAllIsLess: "ALL_IS_LESS",
    filterOperationAllIsMore: "ALL_IS_MORE",
    filterOperationAtLeastOneIsLess: "AT_LEAST_ONE_IS_LESS",
    filterOperationAtLeastOneIsMore: "AT_LEAST_ONE_IS_MORE",
    filterOperationIsNull: "IS_NULL",
    filterOperationIsNotNull: "IS_NOT_NULL",
    viewRequestPayload: "View request payload",
    viewRequestAsCURL: "View request as cURL",
    viewResponseAsOptimizedDataJson: "View response as optimized JSON",
    viewResponseAsFullDataJson: "View response as full JSON",
    viewResponseAsSQL: "View response as SQL",
    viewResponseAsCSV: "View response as CSV",
    copyToClipboardButton: "Copy to clipboard",
    copiedToClipboardMessage: "Copied to clipboard",
    chartTypeBar: "Bar",
    chartTypeLine: "Line",
    chartTypePie: "Pie",
    chartTypeDoughnut: "Doughnut",
    chartTypeRadar: "Radar",
    tablePreviousText: "Previous",
    tableNextText: "Next",
    tableLoadingText: "Loading...",
    tableNoDataText: "No rows found",
    tablePageText: "Page",
    tableOfText: "of",
    tableRowsText: "rows",
    tablePageJumpText: "jump to page",
    tableRowsSelectorText: "rows per page",
    saveButtonText: "Save",
};
